export default __webpack_public_path__ + "static/media/rejected-checked.ab72c12a.svg";